export const PILL_TEXT = 'Customize your transfers';

export const DESCRIPTION_TEXT =
  'Psst, you can now give each transfer its own unique wallpaper.';

export const ACCEPT_BUTTON_TEXT = 'Upgrade to Premium';

export const DISMISS_BUTTON_TEXT = 'Don’t show again';

export const POPOVER_DISMISSED_FOREVER_COOKIE_KEY =
  'wt-custom-wallpaper-upsell-popover_dismissed-forever';
